module.exports = __webpack_public_path__ + "static/media/handshake-active.818f8aa5.svg";